module.exports = __webpack_public_path__ + "static/media/circle-info.d64291fe.svg";